/**
 * 🏪 Netzwerk — mehrere Shops mit eigenen Konten, der Inhaber sieht nur Zahlen.
 * Dünner Wrapper um /api/netzwerk; der Stand wird kurz im Gerät gemerkt, damit die Einstellungen
 * und die Statistik sofort wissen, ob dieses Konto Inhaber eines Netzwerks ist.
 */
import { api } from './apiService';

const KEY = 'kiosk_netzwerk'; // { rolle, name }

function merke(stand) {
  try {
    if (stand && stand.rolle) localStorage.setItem(KEY, JSON.stringify({ rolle: stand.rolle, name: stand.netzwerk && stand.netzwerk.name }));
    else localStorage.removeItem(KEY);
  } catch { /* */ }
  try { window.dispatchEvent(new CustomEvent('kiosk:netzwerk')); } catch { /* */ }
  return stand;
}

/** Zuletzt bekannter Stand ({rolle, name}) oder null — ohne Server-Aufruf. */
export function bekannt() {
  try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; }
}
export function istInhaber() {
  const b = bekannt();
  return !!(b && b.rolle === 'inhaber');
}

export async function lade() { return merke(await api.get('/netzwerk')); }
export async function gruenden(name, shopName) { return merke(await api.post('/netzwerk', { name, shopName })); }
export async function umbenennen(name) { return merke(await api.put('/netzwerk', { name })); }
export async function aufloesen() { await api.delete('/netzwerk'); return merke(null); }
export async function neuerCode() { return merke(await api.post('/netzwerk/code')); }
export async function beitreten(code, shopName) { return merke(await api.post('/netzwerk/beitreten', { code, shopName })); }
export async function verlassen() { await api.post('/netzwerk/verlassen'); return merke(null); }
export async function shopUmbenennen(shopName) { return merke(await api.put('/netzwerk/mitglied', { shopName })); }
export async function entfernen(mitgliedId) { return merke(await api.delete(`/netzwerk/mitglied/${mitgliedId}`)); }
export function uebersicht(tage) { return api.get('/netzwerk/uebersicht', { tage }); }
